// @ts-nocheck
export class FieldsGrid {
	constructor(fields, id, content?) {
		fields.forEach((item) => (item.id = id));
		this.fields = fields;
	}

	public fields;
}
